import { axios } from "../../api";
import router from "../../router";

export default {
    state: {
        table: [],
    },
    getters: {
        table: (state) => state.table,
    },
    actions: {
        GET_TABLE({ commit }) {
            axios
                .get("/getOrder")
                .then((res) => {
                    // console.log(res.data);
                    commit("GET_TABLE", res.data);
                })
                .catch((err) => console.log(err));
        },
        DELETE_ORDER({ commit }, payload) {
            commit("DELETE_ORDER", payload);
        },
    },
    mutations: {
        GET_TABLE(state, payload) {
            state.table = payload;
            window.Echo.channel("cashier-order").listen("CashierOrder", (e) => {
                state.table = e.homes;
            });
        },
        async DELETE_ORDER(state, payload) {
            await axios
                .delete("/deleteOrder/" + payload)
                .then(() => {
                    router.push("/");
                });
        },
    },
};
